// tslint:disable
export var TCSCommunicationOption;
(function (TCSCommunicationOption) {
    // Unspecified
    TCSCommunicationOption[TCSCommunicationOption["Unspecified"] = 0] = "Unspecified";
    // Opt-In
    TCSCommunicationOption[TCSCommunicationOption["OptIn"] = 1] = "OptIn";
    // Opt-Out
    TCSCommunicationOption[TCSCommunicationOption["OptOut"] = 2] = "OptOut";
})(TCSCommunicationOption || (TCSCommunicationOption = {}));
TCSCommunicationOption['UNSPECIFIED'] = 0;
TCSCommunicationOption['OPTIN'] = 1;
TCSCommunicationOption['OPTOUT'] = 2;
//# sourceMappingURL=TCSCommunicationOption.js.map